import { useEffect, useRef } from 'react';
import useAuthentication from '../hooks/useAuthentication';

export default function KioskManager(onLogout: () => void, logoutMinutes: number, checkoutLogoutMinutes: number) {

  // Set kiosk storage item in case utm_source=kiosk is detected
  const query = new URLSearchParams(window.location.search);
  if (query.get('utm_source') === "kiosk")
    localStorage.setItem("lansingnow_kiosk_mode", "True");

  const { isAuthenticated } = useAuthentication();
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  
  // Determine if kiosk mode
  const isKioskMode = localStorage.getItem('lansingnow_kiosk_mode') === "True";

  // Push kiosk GTM data layer variable
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({
      Var_is_kiosk: isKioskMode
  });

  // Auto logout events and logic below
  const resetTimer = () => {
    // Checkout page auto logout period is shorter compared to rest of the app
    let timerMinutes = document.location.pathname === '/checkout/completed/' ? checkoutLogoutMinutes : logoutMinutes;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => { 
      onLogout();
    }, timerMinutes * 60 * 1000);
  };

  useEffect(() => {
    // If visitor or not in kiosk mode, no auto-logout needed
    if (!isAuthenticated || !isKioskMode)
      return;

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

    const handleActivity = () => resetTimer();

    events.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [isAuthenticated, isKioskMode]);
}
